import { Injectable } from '@angular/core';
import { IEmailTemplate } from '../models/email-template.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class EmailTemplatesService {
  private readonly basePath = '/email-templates';

  constructor(private apiService: ApiService) {}

  getList(): Promise<IEmailTemplate[]> {
    return this.apiService.request<IEmailTemplate[]>(this.basePath, 'GET');
  }

  getByKey(key: string): Promise<IEmailTemplate> {
    return this.apiService.request<IEmailTemplate>(
      `${this.basePath}/${key}`,
      'GET',
    );
  }

  getVariablesCatalog(): Promise<Record<string, string[]>> {
    return this.apiService.request<Record<string, string[]>>(
      `${this.basePath}/catalog/variables`,
      'GET',
    );
  }

  create(template: Partial<IEmailTemplate>): Promise<IEmailTemplate> {
    return this.apiService.request<IEmailTemplate>(
      `${this.basePath}/create`,
      'POST',
      template,
    );
  }

  update(template: Partial<IEmailTemplate>): Promise<IEmailTemplate> {
    return this.apiService.request<IEmailTemplate>(
      `${this.basePath}/update`,
      'POST',
      template,
    );
  }

  preview(
    key: string,
    variables: Record<string, string>,
  ): Promise<{ subject: string; html: string; text?: string }> {
    return this.apiService.request(`${this.basePath}/preview`, 'POST', {
      key,
      variables,
    });
  }

  testSend(
    key: string,
    to: string,
    variables: Record<string, string>,
  ): Promise<void> {
    return this.apiService.request(`${this.basePath}/test-send`, 'POST', {
      key,
      to,
      variables,
    });
  }

  seedTemplates(): Promise<void> {
    return this.apiService.request(`${this.basePath}/seed`, 'POST');
  }

  resetDefaults(key: string): Promise<IEmailTemplate> {
    return this.apiService.request<IEmailTemplate>(
      `${this.basePath}/reset-defaults/${key}`,
      'POST',
    );
  }
}
